export default {
  getQuestion: "/yangtse/identify/exam/record/start",
  login: "/yangtse/exam/user/login/account",
  examCenterList: "/yangtse/identify/exam/user/test/center/list",
  oneQuestionSumit: "/yangtse/identify/exam/record/answer",
  submitTest: "/yangtse/identify/exam/record/submit",
  idCardInfoQuery: "/yangtse/handle/pdf/query/idcard",
  subjectCodeCheck: "/yangtse/identify/subject/random/code/check",
};
